// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "additional-1BKf6";
var _5 = "additional_horizontal-3KedU";
var _6 = "head-OsPwW";
var _7 = "head_horizontal-39r9w";
var _8 = "insurance-3CV-Z";
var _9 = "transfer-2ug7Y";
var _a = "logo__wrapper-3aGjM";
var _b = "whiteLines-3QKev";
var _c = "whiteLine_narrow-AMGpP";
var _d = "whiteLine_wide-1imlW";
var _e = "icon-3jexC";
var _f = "header-3e9W8";
var _10 = "content-2bIVp";
var _11 = "title-13xom";
var _12 = "subheader-3mjcv";
var _13 = "footer-23WGW";
var _14 = "buttonBase-3LV2O";
var _15 = "price-GLJJ2";
var _16 = "remove-1zZgn";
var _17 = "button-1mJjT";
var _18 = "button_from-33CtP";
var _19 = "price_notSelected-1FoRo";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "additional", _5 as "additional_horizontal", _6 as "head", _7 as "head_horizontal", _8 as "insurance", _9 as "transfer", _a as "logo__wrapper", _b as "whiteLines", _c as "whiteLine_narrow", _d as "whiteLine_wide", _e as "icon", _f as "header", _10 as "content", _11 as "title", _12 as "subheader", _13 as "footer", _14 as "buttonBase", _15 as "price", _16 as "remove", _17 as "button", _18 as "button_from", _19 as "price_notSelected" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "additional": _4, "additional_horizontal": _5, "head": _6, "head_horizontal": _7, "insurance": _8, "transfer": _9, "logo__wrapper": _a, "whiteLines": _b, "whiteLine_narrow": _c, "whiteLine_wide": _d, "icon": _e, "header": _f, "content": _10, "title": _11, "subheader": _12, "footer": _13, "buttonBase": _14, "price": _15, "remove": _16, "button": _17, "button_from": _18, "price_notSelected": _19 }
